import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img 
              src="/hgds-logo-footer.png" 
              alt="HGDS Logo" 
              className="h-16 w-auto object-contain"
            />
          </div>

          {/* Navigation Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <button onClick={() => scrollToSection('fooldal')} className="text-gray-300 hover:text-white transition-colors">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('szolgaltatasok')} className="text-gray-300 hover:text-white transition-colors">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('rolunk')} className="text-gray-300 hover:text-white transition-colors">
              {t.nav.about}
            </button>
            <button onClick={() => scrollToSection('kapcsolat')} className="text-gray-300 hover:text-white transition-colors">
              {t.nav.contact}
            </button>
          </div>

          {/* Copyright */}
          <div className="text-gray-400 text-sm">
            {t.footer.copyright}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;